import { ShieldCheck } from "lucide-react";

const manifest = {
  key: "delegation_permissions_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: ShieldCheck,
  names: {
    plan: {
      en: "Delegation & Permissions Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0641\u0648\u064a\u0636 \u0648\u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0627\u062a",
      "zh-Hans": "授权与权限管理",
    },
    dashboard: {
      en: "Delegation & Permissions Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0641\u0648\u064a\u0636 \u0648\u0627\u0644\u0635\u0644\u0627\u062d\u064a\u0627\u062a",
      "zh-Hans": "授权与权限管理",
    },
  },
  defaultPath: "/delegation-dashboard",
  matchers: [
    /^\/delegation-dashboard(?:\/|$)/,
    /^\/delegates\/permissions(?:\/|$)/,
    /^\/delegates\/new(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel, isAuthorizedOnly }) =>
    !isAuthorizedOnly
      ? [
          {
            label: activeModuleLabel,
            path: "__delegation_management__",
            children: [
              { label: t("dashboard"), path: "/delegation-dashboard" },
              // Delegates are created only from Permissions Management, which checks the free
              // allowance and wallet balance first.
              {
                label:
                  t("menu_permissions_management") || "Permissions Management",
                path: "/delegates/permissions",
              },
            ],
          },
        ]
      : [],
};

export default manifest;
